import { EntitiesToExtract } from '@/widgets/ExtractFormData/types';

export const getExtractedFormState = <T extends Partial<EntitiesToExtract>>(
  entity: T,
  allowedFields: Readonly<Array<keyof T>>,
) => {
  const extractedData: Partial<T> = {};

  for (const field of allowedFields) {
    if (Object.prototype.hasOwnProperty.call(entity, field)) {
      extractedData[field] = entity[field];
    }
  }

  return extractedData;
};
